module.exports = __webpack_public_path__ + "static/media/mathieu_french.e38f6018.mp3";